module.exports = __webpack_public_path__ + "media/2.d27306e9.wav";